import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

const baseUrl = process.env.REACT_APP_REPORT_API_URL;

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export const ModalFacturasGeneradas = (props) => {
  const classes = useStyles();

  const [loading, setLoading] = React.useState(false);

  const openLoadingHandler = () => {
    setLoading(true);
  };

  const closeLoadingHandler = () => {
    setLoading(false);
  };

  const { open } = props;

  useEffect(() => {
    if (open) openLoadingHandler(true);
  }, [open]);

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Facturas Generadas</DialogTitle>
        <DialogContent>
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <iframe
            title="Reportes"
            // src={`${baseUrl}/Reportes/ViewReportFacturacionGenerada/${props.idtipoAfiliacion}/${props.fecha}`}
            src={`${baseUrl}/Reportes/ViewReportFacturacionGenerada/${props.idtipoAfiliacion}/${props.periodo}`}
            style={{ height: `80vh`, width: `90vw` }}
            onLoad={closeLoadingHandler}
          />
          <div style={{ textAlign: "right", marginTop: "0.5rem" }}>
            <Button onClick={props.onClose} type="button" color="primary">
              Cancelar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
